import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { SixSummary } from "@/types/six/Six";
import type { SixCatalogState } from "@/types/six/SixState";
import { fetchSixCatalog } from "@/store/thunks/sixCatalog/fetchSixCatalog";
import { deleteSixThunk } from "@/store/thunks/six/deleteSixThunk";

const initialState: SixCatalogState = {
  sixes: [],
  loading: false,
  error: undefined,
  search: undefined,
};

export const catalogSlice = createSlice({
  name: "catalog",
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string | undefined>) {
      const {payload} = action;
      state.search = payload;
    },
    resetCatalogState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSixCatalog.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchSixCatalog.fulfilled, (state, action: PayloadAction<SixSummary[]>) => {
        const { payload } = action;
        state.sixes = payload;
        state.loading = false;
      })
      .addCase(fetchSixCatalog.rejected, (state, action) => {
        state.loading = false;
        const { error: { message } } = action;
        state.error = message;
      })
      .addCase(deleteSixThunk.fulfilled, (state, action) => {
        const deletedId = action.meta.arg.id;
        state.sixes = state.sixes.filter((six) => six.id !== deletedId);
      });
  },
});

const { actions } = catalogSlice;
export const { setSearch, resetCatalogState } = actions;
export default catalogSlice.reducer;
